import mapConfig from "../config/mapConfig.js";
import filtersConfig from "../config/filtersConfig.js";
import tableConfig from "../config/tableConfig.js";

// Dette er applikasjonens globale tilstand (state) som brukes av Vuex.
export default {    
  // Spørringsuttrykk for stasjoner fra andre aktører
  queryExpressionStationsFromOtherActors: "DATA_EIER_KATEGORI <> 'NVE' AND PARAMETERNAVN IN ('Nedbør', 'Temperatur', 'Snødybde')", 
  // Filterkonfigurasjon for stasjoner fra andre aktører
  filtersStationsFromOtherActors: filtersConfig.filtersStationsFromOtherActors,   
  // Aktive filtre
  filters: [],
  // Hvilken tab er aktiv i tabellen
  activeTableTab: null,
  // Viser dialog for å velge objekt i kartet
  showSelectFeatureDialog: false,
  // Om popup-vinduer skal vises i kartet
  showPopups: true,
  // Valgte tidsserier (NVE)
  selectedTimeSeries: [],
  // Valgte tidsserier fra andre aktører
  selectedTimeSeriesOtherActors: [],
  // Om filterpanelet skal vises
  showFilterPanel: true,
  // Hvilken tab er aktiv i informasjons-skuffen
  activeInfoDrawerTab: null,
  // Om stasjoner fra andre aktører skal vises i kartet
  showStationsFromOtherActors: false,
  // Om velkomstmelding i filter-skuffen skal skjules (lagres i localStorage)
  hideWelcomeMessageInFilterDrawer: JSON.parse(window.localStorage.getItem('hideWelcomeMessageInFilterDrawer')),
  // Innstillinger for symbolisering av hovedlaget i kartet
  mainLayerSymbolSettings: {
    size: {
      value: 10,
      labelSize: 10,
      yOffset: 20
    },
    color: "#1976d2"
  },
  // Filtermodus for år (fullt eller delvis dekket tidsrom)
  yearFilterMode: {
    id: "parts",
    name: "Dekker deler av tidsrommet"
  },
  // Valgt bakgrunnskart
  selectedBasemap: null,
  // Om informasjons-skuffen skal vises
  showInfoDrawer: false,
  // Tidsserier som er klikket på i kartet
  clickedTimeSeries: [],
  // Størrelse på splitt (for layout)
  splitSize: [],
  // Antall tidsserier funnet
  timeSeriesCount: 0,
  // Tabellhoder for andre aktørers tidsserier
  otherTimeseriesHeaders: tableConfig.otherTimeSeriesHeaders,
  // Tabellhoder for NVE tidsserier
  vheaders: tableConfig.timeSeriesHeaders,
  // Valgte kolonner i tabellen (NVE)
  selectedColumns: tableConfig.selectedColumns,
  // Valgte kolonner i tabellen (andre aktører)
  selectedColumnsOtherActors: tableConfig.selectedColumnsOtherActors,
  // Valgte måleparametre
  selectedMaaleParameter: [],
  // Fra-år for filtrering
  fromYear: null,
  // Til-år for filtrering
  toYear: null,
  // Spørringsuttrykk for hovedlaget
  queryExpression: '1=1',
  // Geografiske filtervalg
  geographicFilterOptions: filtersConfig.geographicFilterOptions,
  // Om kartet er lastet inn
  mapLoaded: false,
  // Verdier for aktive filtre
  filterValues: {},
  // Aktiv modus for geografisk filter
  activeGeographicFilterMode: 'Ingen kartavgrensning',
  // Om kartet har blitt lastet inn (kan overlappe med mapLoaded)
  mapHasLoaded: false,
  // Om buffer skal brukes for geografisk søk
  useBuffer: false,
  // Bufferinnstillinger
  bufferSettings: null,
  // Om kartutstrekning skal brukes for søk
  useMapExtent: false,
  // Standard kartutstrekning
  defaultMapExtent: mapConfig.defaultMapExtent,
  // Nåværende kartutstrekning
  currentMapExtent: mapConfig.currentMapExtent,
  // Kartkonfigurasjon
  kart: mapConfig,
  // Dato-område for grafvisning
  chartDateRange: {
    start: new Date(new Date().setMonth(new Date().getMonth() - 2)),
    end: new Date()
  },
  // Om filtre er under lasting
  filtersAreLoading: true
}